import styled, { css } from 'styled-components'

export const TimelineItemContainer = styled.div<{ isSelected: boolean }>`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  cursor: pointer;

  span {
    transition: transform 0.5s ease-in-out;
  }
  &:hover {
    span {
      transform: scale(1.3);
    }
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      span {
        transform: scale(1.3);
        color: ${({ theme }) => theme.colors.primary};
      }
    `}
`

export const TimelineCircleContainer = styled.div`
  width: 12px;
  height: 8px;
  margin-top: 22.5px;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
`

export type TimelineCircleProps = {
  isColored: boolean
}

export const TimelineCircle = styled.span<TimelineCircleProps>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  border-color: ${({ isColored, theme }) =>
    isColored ? theme.colors.primary : theme.colors.lightgray};
  background-color: ${({ isColored, theme }) =>
    isColored ? theme.colors.primary : theme.colors.lightgray};
`
